import { render, staticRenderFns } from "./LoaderUniColor.vue?vue&type=template&id=6449749d&scoped=true"
import script from "./LoaderUniColor.vue?vue&type=script&lang=js"
export * from "./LoaderUniColor.vue?vue&type=script&lang=js"
import style0 from "./LoaderUniColor.vue?vue&type=style&index=0&id=6449749d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6449749d",
  null
  
)

export default component.exports